import React from 'react';
import {RegulatoryDocumentParagraph} from 'types';
import {
	ComparisonUpdateAllPossibleFields,
	ComparisonUpdateFields,
	ComparisonUpdateFieldType,
} from '../components/DocumentCompare/CompareVersionPanel/compareVersionTypes';

export const useParagraphMetadataUpdader = () => {
	const updateParagraphMetadata = (
		currentParagraph: RegulatoryDocumentParagraph,
		input: RegulatoryDocumentParagraph,
		selectedFields: ComparisonUpdateFields,
	): RegulatoryDocumentParagraph => {
		const isSelected = (field: ComparisonUpdateFieldType) =>
			selectedFields.indexOf(field) > -1;
		const ret = {
			...currentParagraph,
		};

		ComparisonUpdateAllPossibleFields.forEach(
			(possibleField: ComparisonUpdateFieldType) => {
				if (isSelected(possibleField)) {
					ret[possibleField] = input[possibleField];
				}
			},
		);
		return ret;
	};

	return {updateParagraphMetadata};
};
